import { dot, Fn, max, normalize, reflect } from "three/tsl"

export const ambientLight = Fn(([lightColor, lightIntensity]: [any, any]) => {
  return lightColor.mul(lightIntensity)
})

export const dirLight = Fn(
  ([lightDirection, lightIntensity, lightColor, normal]: [
    any,
    any,
    any,
    any,
  ]) => {
    const dir = normalize(lightDirection)
    const angle = max(0.0, dot(dir, normal))
    const diffuse = angle

    const light = diffuse.mul(lightIntensity).mul(lightColor)
    return light
  },
)

export const phongSpecular = Fn(
  ([viewDirection, lightDirection, normal, glossiness]: [
    any,
    any,
    any,
    any,
  ]) => {
    const reflectDir = normalize(reflect(lightDirection, normal))
    const phongValue = max(0.0, dot(viewDirection, reflectDir))
    const specular = phongValue.pow(glossiness)
    return specular
  },
)
